module.exports = __webpack_public_path__ + "img/logo-veroniquelesourd.00e7898c.png";